import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_BASE } from '../../core/constants';
import { HttpUtils } from '../http-utils';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  constructor(private http: HttpClient) {
  }

  public getTimezones(): Observable<string[]> {
    const url     = `${URL_BASE}/api/timezones`;
    const headers = HttpUtils.createHeaders();

    return this.http.get<string[]>(url, { headers });
  }

  public getTimezoneIds(): Observable<string[]> {
    const url     = `${URL_BASE}/api/timezoneIds`;
    const headers = HttpUtils.createHeaders();

    return this.http.get<string[]>(url, { headers });
  }
}
